import type { z } from 'zod';

/**
 * A project row's SKU can be longer than the create endpoints accept.
 *
 * The from-catalog server path snapshots the blueprint SKU verbatim, and the
 * catalog schema allows 80 characters, while the panel, countertop and cabinet
 * request schemas cap `sku` at 50. Requests go through a strict validation pipe, so handing an
 * oversized SKU to the create endpoint rejects the whole body with a 400 and
 * the copy cannot be saved at all.
 *
 * So the SKU only rides along when the create schema itself accepts it — the
 * limit is read off that schema rather than restated here. It is never
 * truncated: a shortened SKU is a different SKU and could collide with a real
 * one, and a copy without a SKU still saves.
 */
type SkuFieldSchema = z.ZodType<string | undefined, z.ZodTypeDef, string | undefined>;

export function skuForCopy(
  sku: string | null | undefined,
  skuField: SkuFieldSchema,
): string | undefined {
  if (!sku) return undefined;
  const parsed = skuField.safeParse(sku);
  return parsed.success ? parsed.data : undefined;
}
